// Subscription stub schemas — Stripe is stubbed at month 12 (no SDK / webhooks).
// These shapes drive the in-app state machine via dev-only triggers.
import { z } from 'zod';

import { idSchema } from './common.js';

export const subscribeInputSchema = z.object({
  venue_account_id: idSchema,
  tier: z.enum(['founding', 'standard', 'premium']),
  billing_cycle: z.enum(['monthly', 'annual']).default('monthly'),
});
export type SubscribeInput = z.infer<typeof subscribeInputSchema>;

export const changeTierInputSchema = z.object({
  subscription_id: idSchema,
  to_tier: z.enum(['founding', 'standard', 'premium']),
});
export type ChangeTierInput = z.infer<typeof changeTierInputSchema>;

export const pauseSubscriptionInputSchema = z.object({
  subscription_id: idSchema,
});
export type PauseSubscriptionInput = z.infer<typeof pauseSubscriptionInputSchema>;

export const resumeSubscriptionInputSchema = z.object({
  subscription_id: idSchema,
});
export type ResumeSubscriptionInput = z.infer<typeof resumeSubscriptionInputSchema>;

export const cancelSubscriptionInputSchema = z.object({
  subscription_id: idSchema,
  reason: z.string().max(500).optional(),
});
export type CancelSubscriptionInput = z.infer<typeof cancelSubscriptionInputSchema>;

// Dev-only stub — drives state machine without a real Stripe webhook.
export const simulateBillingEventInputSchema = z.object({
  subscription_id: idSchema,
  event: z.enum([
    'trial_ended_charge_success',
    'trial_ended_charge_failure',
    'recurring_charge_success',
    'recurring_charge_failure',
    'retry_success',
    'retry_exhausted',
  ]),
});
export type SimulateBillingEventInput = z.infer<typeof simulateBillingEventInputSchema>;
